import React, { Component } from 'react'
import {
    Card, CardHeader, CardImg, CardBody, CardText
} from 'reactstrap'
import { Link } from 'react-router-dom'
import Share from '../../../components/facebook/share'
import { animations } from 'react-animation'

export default class ProductItemAdmin extends Component {
    render() {
        return (
            <Card className="itemProducto" style={{ animation: animations.popIn }} >
                <CardHeader>{this.props.product.Descripcion}</CardHeader>
                {
                    this.props.product.Img &&
                    <CardImg top width="100%" src={this.props.product.Img} alt="Card image cap" />
                }
                <CardBody>
                    {/* <CardTitle>Special Title Treatment</CardTitle> */}
                    <CardText>{this.props.product.Detalle}</CardText>
                    {/* <Button className="btn-rojo">Ver más</Button>   */}
                    <Link className="btn btn-rojo btn-sm" to={`/producto/`}>Ver más</Link>{' '}
                    <Share url={`${window.location.hostname}/producto/`}/>
                </CardBody>
            </Card>
        )
    }
}